import * as React from 'react';
import { DropDown, Form, Input, LookUpDropDown, Switch } from '../../library';
import { IFormData, IFormState, SystemFormDetail } from '../../library/form/SystemFormDetail';
import { HttpService } from 'library';

interface IDataModel extends IFormData {
    PrimaryKeyEncrypted?: string,
    LookupId?: string,
    DataText?: string,
    DataValue?: string,
    Status?: 'Pending',
    Description?: string,
    Ordinal?: number,
    Active?: true,
}

export default class AddLookupRequestForm extends SystemFormDetail<IDataModel> {
    constructor(props: any) {
        super(props);
    }

    initial = (): IFormState<IDataModel> => {
        return {
            formData: {
                PrimaryKeyEncrypted: (this.props.data && this.props.data.PrimaryKeyEncrypted) ? this.props.data.PrimaryKeyEncrypted : undefined,
                Status: 'Pending',
                Active: true
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    LookupId: data.LookupId,
                    DataText: data.DataText,
                    DataValue: data.DataValue,
                    Status: data.Status,
                    Description: data.Description,
                    Ordinal: data.Ordinal,
                    Active: data.Active,
                    RowVersion: data.RowVersion,
                }
            })
        }
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.fetchLookupData();
        }, 1000)
    }

    fetchLookupData = () => {
        let lookupTableUrl = '/LookupRequest/LookupTableGet';
        if (!this.state.formData.PrimaryKeyEncrypted) {
            HttpService.get(lookupTableUrl)
                .then((data) => {
                    let lookup = data.data.filter(item => item.LookupName === this.props.data.LookupTable);
                    this.setState(prevState => ({
                        formData: {
                            ...prevState.formData,
                            LookupId: lookup[0].LookupId
                        }
                    }));
                })
                .catch((error) => {
                    console.error('Error fetching lookup data:', error);
                });
        }
    }

    render() {
        let lookupTableUrl = '/LookupRequest/LookupTableGet';

        return (<>
            <Form
                label="Lookup"
                url={'LookupValue'}
                onLoad={this.load}
                showReview={false}
                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                securityObject="Top.LookupValue"
                schema="Lookup" table="LookupValue"
                onInitialize={this.initialize}
                onClear={this.initialize}
                onValidate={this.validate}
                onPrepare={this.prepare}
                onRecordUpdated={this.onRecordUpdated}>

                <div className="col-md-4 col-12 mb-2">
                    <DropDown
                        id="LookupId"
                        name="LookupId"
                        label='Lookup Table'
                        dataSource={lookupTableUrl}
                        displayField="LookupName"
                        idField="LookupId"
                        labelClass="col-12"
                        componentClass="col-12"
                        isRequired={true}
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.LookupId} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="DataText"
                        name="DataText"
                        label='Lookup Name'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        value={this.state.formData.DataText}
                        validator={this.validator} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        isRequired={true}
                        id="DataValue"
                        name="DataValue"
                        label='Lookup Value'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        value={this.state.formData.DataValue}
                        validator={this.validator} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Input
                        id="Ordinal"
                        name="Ordinal"
                        type="number"
                        minValue="1"
                        label='Sort Order'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.Ordinal} />
                </div>

                <div className="col-md-4 col-12 mb-2">
                    <Switch
                        id='Active'
                        name='Active'
                        label='Active'
                        labelFormat='nocase'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        validator={this.validator}
                        value={this.state.formData.Active} />
                </div>
            </Form>
        </>)
    }
};